import  ApiService  from '../../services/api.service'
import { TokenService } from '../../services/storage.service';
import HashMake from '../../services/hash.service';

const state =  {
    additionalServices: [],
    servicesLoading: false,
    cartServiceLoading: false
}

const getters = {
    additionalServices: state => state.additionalServices,
    servicesLoading: state => state.servicesLoading,
    cartServices: state => state.cartServices,
    cartServiceLoading: state => state.cartServiceLoading
}

const mutations = {
    setAdditionalServices(state, services) {
        state.additionalServices = services
    },
    setServicesLoading(state, status) {
        state.servicesLoading = status
    },
    setCartServices(state, cartServices) {
        state.cartServices = cartServices
    },
    setCartServiceLoading(state, cartServiceLoading) {
        state.cartServiceLoading = cartServiceLoading
    }
}

const actions = {
    getAdditionalServices({commit}, Payload) {
        let locale_id = (Payload.lang == 'fi_FI') ? 2 : 1
        commit('setServicesLoading', true)
        return new Promise((resolve, reject) => {
            const token = TokenService.getToken();
            const anonymousId = TokenService.getGuestToken();
            let   queryString = {locale_id: locale_id};
            if(!token && !anonymousId) {
                return;
            }
            if (anonymousId) {
                queryString.anonymous_id=anonymousId;
            }
            if (Payload.dealer_id !== null) {
                queryString.dealer_id = Payload.dealer_id;
            }

            ApiService.get('/service', {params : queryString})
            .then(response => {
                commit('setAdditionalServices', HashMake.decrypt(response.data.data))
                resolve()
            }).catch((e) => {
                reject()
            }).finally(() => {
                commit('setServicesLoading', false);
            })
        });
    },
    // addCustomerServiceInCart() {

    // },
    // addAnonymousUserServiceInCart() {

    // },
    addServicesInCart({commit}, details) {
        let cartServices = details.services
        commit('setCartServiceLoading', true);
        const token = TokenService.getToken()
        for(let sKey in cartServices) {
            let params = {
                'cart_id': details.cartId,
                'type': 'service',
                'type_id': cartServices[sKey].service_id,
                'quantity': 1
            }
            if(token) {
                if(cartServices[sKey].type=="price_per_quantity"){
                    for(let product in cartServices[sKey].cartProducts) {
                        params.line_item_id = cartServices[sKey].cartProducts[product].id
                        params.quantity = cartServices[sKey].cartProducts[product].qty
                        ApiService.post('/customer/cart/item/insert', params,
                        { 'headers': { 'token': token} })
                        .then(response => {
                            commit('setCartServices', response.data)
                        }).catch((e) => {
                            
                        }).finally(() => {
                        })
                    }
                } else {
                    ApiService.post('/customer/cart/item/insert', params,
                    { 'headers': { 'token': token} })
                    .then(response => {
                        commit('setCartServices', response.data)
                    }).catch((e) => {
                        
                    }).finally(() => {
                    })
                }
            } else {
                let anonymousId = ''
                if(TokenService.getGuestToken()) {
                    anonymousId = TokenService.getGuestToken()
                } else {
                    TokenService.setGuestToken()
                    anonymousId = TokenService.getGuestToken() 
                }
                params.anonymous_id = anonymousId
                if(cartServices[sKey].type=="price_per_quantity"){
                    for(let product in cartServices[sKey].cartProducts) {
                        params.line_item_id = cartServices[sKey].cartProducts[product].id
                        ApiService.post('/anonymous/cart/item/insert', params)
                        .then(response => {
                            commit('setCartServices', response.data)
                            if(response.data.errors) {
                                product.error = response.data.error
                            }
                        }).catch((e) => {
                            
                        }).finally(() => {
                        })
                    }
                } else {
                    ApiService.post('/anonymous/cart/item/insert', params)
                    .then(response => {
                        commit('setCartServices', response.data)
                        if(response.data.errors) {
                            product.error = response.data.error
                        }
                    }).catch((e) => {
                        
                    }).finally(() => {
                    })
                }
                
            }
        }
        commit('setCartServiceLoading', false);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}